import {
  ArrowRightIcon as ArrowRight,
  DotIcon,
  Typography
} from "@packages/ds";
import styled, { css as styledCSS, keyframes } from "styled-components";

import Button, { Link } from "ds/Button";
import * as Dropdown from "ds/Dropdown";
import * as Tabs from "ds/Tabs";

const bump = keyframes`
  0% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.97);
  }
  80% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
  }
`;
export const StepLabel = styled.div`
  display: flex;
  align-items: center;
`;

export const TabsList = styled(Tabs.List)`
  margin: 8px 0 0 0;
`;
export const RequiredDotIcon = styled(DotIcon)`
  width: 12px;
  height: 12px;
  fill: var(--icon-color-secondary-500-fill, var(--color-secondary-500));
`;

export const CodeInstallLabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const Wrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  margin-bottom: 32px;
  background-color: var(--section-snow-background-color, var(--snow));
  border-radius: 2px;
  box-shadow: var(--section-box-shadow-box-shadow, var(--box-shadow))
    var(--section-granite-box-shadow-color, var(--granite));
  outline: none;

  &:focus {
    outline: none;
  }

  ${props =>
    props.animate &&
    styledCSS`
      animation: ${bump} 300ms ease-out;
    `};
`;

export const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  &::before {
    content: "";
    display: block;
    height: 2px;
    width: ${props => props.completed || 0}%;
    background-color: var(
      --section-color-primary-600-background-color,
      var(--color-primary-600)
    );
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 24px 24px 0 32px;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 32px 32px 32px;
`;

export const Pipe = styled.hr`
  height: 24px;
  width: 1px;
  margin: 0px;
  background-color: var(--mode-bg-neutral-weak);
`;

const FooterButton = styled(Button)`
  display: flex;
  transition: all 0.1s ease;

  &:hover {
    &:after {
      display: none;
    }
  }
`;

export const BackBtn = styled(FooterButton)`
  margin-left: -7px;
  margin-right: 5px;
  padding-left: 7px;
  padding-right: 4px;

  &:hover {
    padding-left: 0;
    padding-right: 11px;
  }
`;

export const ForwardBtn = styled(FooterButton)`
  padding-left: 10px;
  margin-left: 5px;

  ${ArrowRight} {
    margin-left: 3px;
    transition: all 0.1s ease;
  }

  &:hover ${ArrowRight} {
    margin-left: 10px;
  }
`;

export const SetupTipsWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  margin-bottom: 32px;
  padding: 24px;
  background-color: var(--section-snow-background-color, var(--snow));
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  outline: none;

  &::after {
    content: "";
    position: absolute;
    top: -1px;
    bottom: -1px;
    left: -1px;
    right: -1px;
    background: linear-gradient(to right, #ff4a11, #ed49f0, #ddf933);
    z-index: -1;
    border-radius: var(
      --box-wrapper-section-border-radius,
      var(--section-8px-border-radius, var(--8px))
    );
  }
  &:focus {
    outline: none;
  }
`;

export const SetupWrapper = styled.div`
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  position: relative;
  z-index: 0;
`;

export const InfoWrapper = styled.div`
  display: flex;
`;

export const IconWrapper = styled.div`
  margin-right: 6px;
  margin-bottom: 12px;
`;

export const EbonyLightBodyText = styled(Typography.BodyText)`
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const EbonyBodyText = styled(Typography.BodyText)`
  color: var(--section-ebony-color, var(--ebony));
`;

export const CopyWrapper = styled.div`
  margin: 16px 0;
  code {
    white-space: nowrap;
    background-color: transparent;
    color: var(--section-snow-color, var(--snow));
  }
`;

export const CopyLabel = styled.div`
  margin: 0 0 8px 0;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: var(--section-slate-color, var(--slate));
`;

export const LinkButton = styled(Link)`
  margin: 0 0 8px 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: var(
    --content-wizard-link-section-color,
    var(--section-color-secondary-500-color, var(--color-secondary-500))
  );
`;

export const DropdownTrigger = styled(Dropdown.Trigger)`
  padding-left: unset;
`;

export const DropdownLabel = styled(Dropdown.Label)`
  margin-right: auto;
  padding-left: unset;
  padding-right: unset;
`;
